module.exports = "/_next/static/images/favicon-96x96-21a939b7ca020e126d00d9c0a1d22112.png";